/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  RESET_PASSWORD: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.resetPassword.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'RESET_PASSWORD' },
      },
    },
    RESET_PASSWORD: {
      invoke: {
        id: 'resetPassword',
        src: 'resetPassword',
        onDone: {
          target: 'RESET_PASSWORD_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'RESET_PASSWORD_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    RESET_PASSWORD_SUCCESS: {
      type: 'final',
    },
    RESET_PASSWORD_FAILED: {
      on: {
        START: { target: 'RESET_PASSWORD' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
